module.exports = __webpack_public_path__ + "img/heart_11.a821912b.png";